module.exports = __webpack_public_path__ + "static/media/button-plus.e6299d6d.svg";